export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:8080';
// export const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || 'https://batamx.velintech.com';

export const customerPortalUrl = (code: string) => {
  const customerPortalUrl = process.env.REACT_APP_CUSTOMER_PORTAL_URL || 'batamx.co'
  if (customerPortalUrl?.includes('localhost')) {
    return `http://${code}.localhost:3001`
  }

  return `https://${code}.${customerPortalUrl}`;
}

export const apiUrl = {
  auth: {
    login: `/auth/login`,
    register: `/auth/register`,
    firstChangePassword: `/auth/first-change-password`,
    changeProject: `/auth/change-project-access`,
  },
  roleAccess: {
    list: `/role-access`,
  },
  user: {
    list: `/user`,
    get: (userId: string) => `/user/${userId}`,
    create: `/user`,
    update: (userId: string) => `/user/${userId}`,
  },
  shortUrl: {
    get: (code: string) => `/short-url/${code}`,
    expire: (code: string) => `/short-url/${code}/expire`,
    resetPassword: (userId: string) => `/short-url/reset-password/${userId}`,
    generate: `/short-url/generate`,
  },
  customer: {
    list: `/customer/admin`,
    get: (customerId: string) => `/customer/${customerId}`,
    create: `/customer`,
    update: (customerId: string) => `/customer/${customerId}`,
    delete: (customerId: string) => `/customer/${customerId}`,
  },
  project: {
    list: `/project`,
    get: (projectId: string) => `/project/id/${projectId}`,
    create: `/project`,
    update: (projectId: string) => `/project/${projectId}`,
    delete: (projectId: string) => `/project/${projectId}`,
    setting: {
      detail: `/project/setting`,
      update: `/project/setting`,
    }
  },
  product: {
    list: `/product`,
    listOrder: `/product/order`,
    get: (productId: string) => `/product/${productId}`,
    create: `/product`,
    update: (productId: string) => `/product/${productId}`,
    delete: (productId: string) => `/product/${productId}`,
  },
  productCategory: {
    list: `/product/category`,
    get: (productCategoryId: string) => `/product/category/${productCategoryId}`,
    create: `/product/category`,
    update: (productCategoryId: string) => `/product/category/${productCategoryId}`,
    delete: (productCategoryId: string) => `/product/category/${productCategoryId}`,
  },
  productConfig: {
    list: (productId: string) => `/product/${productId}/config`,
    get: (productId: string, productConfigId: string) => `/product/${productId}/config/${productConfigId}`,
    create: (productId: string) => `/product/${productId}/config`,
    update: (productId: string, productConfigId: string) => `/product/${productId}/config/${productConfigId}`,
  },
  order: {
    list: `/order`,
    get: (orderId: string) => `/order/${orderId}`,
    create: `/order`,
    update: (orderId: string) => `/order/${orderId}`,
    updateStatus: (orderId: string) => `/order/${orderId}/status`,
  },
  customOrder: {
    list: `/order/custom`,
    get: (orderCustomId: string) => `/order/custom/${orderCustomId}`,
    create: `/order/custom`,
    update: (orderCustomId: string) => `/order/custom/${orderCustomId}`,
    updateStatus: (orderCustomId: string) => `/order/custom/${orderCustomId}/status`,
  },
  setting: {
    listStatus: `/setting/order.status`,
    listColor: `/setting/product.color`,
  },
  notification: {
    list: (type: string) => `/notification/list/${type}`,
    sendBatch: `/notification/send-batch`,
  },
  service: {
    list: `/service`,
    get: (serviceId: string) => `/service/${serviceId}`,
    create: `/service`,
    update: (serviceId: string) => `/service/${serviceId}`,
    delete: (serviceId: string) => `/service/${serviceId}`,
    types: `/service/types`,
    customForm: {
      list: `/service/custom-form`,
      create: `/service/custom-form`,
      update: (serviceCustomFormId: string) => `/service/custom-form/${serviceCustomFormId}`,
      delete: (serviceCustomFormId: string) => `/service/custom-form/${serviceCustomFormId}`,
    },
    type: {
      list: `/service/types`,
      create: `/service/type`,
      update: (serviceTypeId: string) => `/service/type/${serviceTypeId}`,
      delete: (serviceTypeId: string) => `/service/type/${serviceTypeId}`,
    }
  },
  booking: {
    list: `/service/booking`,
    get: (bookingId: string) => `/service/booking/${bookingId}`,
    create: `/service/booking`,
    update: (bookingId: string) => `/v2/service/booking/${bookingId}`,
    attendedBy: `/service/attended-by`,
  },
  reward: {
    list: `/rewards/points`,
    get: (pointHistoryId: string) => `/rewards/points/${pointHistoryId}`,
    create: `/rewards/points`,
    update: (pointHistoryId: string) => `/rewards/points/${pointHistoryId}`,
    delete: (pointHistoryId: string) => `/rewards/points/${pointHistoryId}`,
  },
  campaign: {
    list: `/campaign`,
    get: (campaignId: string) => `/campaign/detail/${campaignId}`,
    create: `/campaign/create`,
    update: (campaignId: string) => `/campaign/update/${campaignId}`,
    delete: (campaignId: string) => `/campaign/delete/${campaignId}`,
  },
  promo: {
    list: `/promo`,
    get: (promoId: string) => `/promo/detail/${promoId}`,
    create: `/promo/create`,
    update: (promoId: string) => `/promo/update/${promoId}`,
    delete: (promoId: string) => `/promo/delete/${promoId}`,
  },
  file: {
    upload: `/file/upload`,
  },
  invoice: {
    list: `/invoice`,
    get: (invoiceId: string) => `/invoice/${invoiceId}`,
    getBySourceId: (sourceId: string) => `/invoice/source/${sourceId}`,
    create: `/invoice`,
    update: (invoiceId: string) => `/invoice/${invoiceId}`,
    delete: (invoiceId: string) => `/invoice/${invoiceId}`,
  }
}
